// extracted by mini-css-extract-plugin
export default {"content":"Modal_content__h4eZL","modal":"Modal_modal__zPxGk"};